import {  useState } from 'react';
import { Formik } from 'formik';
import { useGetCalculatorConstants } from '@/query/queries/calculator/useGetCalculatorConstants';
import { LOAN_GROUPS_IDS } from '@/helpers/constants';
import { InvestmentTypes } from './components/InvestmentTypes';
import { FormObserver } from './components/FormObserver';
import { Settings } from './components/Settings';
import { Result } from './components/Result';
import { Graph } from './components/Graph';
import s from './index.module.scss';

export const GrowthCalculator = () => {
  const { data: constants } = useGetCalculatorConstants()
  const [result, setResult] = useState({ isLoading: false, isError: false, data: undefined });

  if (!constants) return null;

  return (
    <Formik
      onSubmit={() => null}
      initialValues={{
        initial: 1000,
        monthly_investment: 100,
        term: 36,
        group_id: LOAN_GROUPS_IDS.conservative.id,
        is_bonuses_included: true,
      }}
    >
      {() => (
        <>
          <FormObserver setResult={setResult} />
          <div className={s.wrapper}>
            <Settings state={constants} />
            <Result data={result} />
            <Graph data={result} />
          </div>
          <InvestmentTypes
            data={{ ...constants, scramble_irr: result.data?.irr }}
            className={s.other}
          />
        </>
      )}
    </Formik>
  );
};
